import React from 'react'
import { CiLogout } from 'react-icons/ci';

const LogoutModal = ({logout,closeModal,isOpen}) => {
    if (!isOpen) return null;
    return (
        <div>
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
            >
                <div className="bg-white w-11/12 sm:w-1/2 lg:w-1/4 rounded-lg shadow-lg p-6 text-center">
                    <div className="flex justify-center">
                        <CiLogout className="h-16 w-16 text-[#ED3636] mb-4" />
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-800">Logout Account</h2>
                    <p className="text-gray-500 mt-2 mb-6">
                    Are you sure you want to log out?
                    </p>
                    <div className="flex justify-center space-x-4">
                        <button
                            onClick={closeModal}
                            className="px-6 py-2 text-[#ED3636] border border-[#ED3636] rounded-lg hover:bg-[#ED3636] hover:text-white transition"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={logout}
                            className="px-6 py-2 text-white bg-[#ED3636] rounded-lg hover:bg-red-600 transition"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LogoutModal